import { useEffect, useState } from 'react'
import { useWireState } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import useAbortableFetch from '@hook/useAbortableFetch'
import DocumentSearchResultsTable from '@components/collection/Collection/DocumentSearchResultsTable'
import {
    ES_ENGINE_DOCUMENTS,
    ES_ENGINE_INDEX_DOCUMENTS,
    ES_INDEX_SUFFIXES_BY_STRATEGY,
    ES_INDEX_STRATEGY_INNER,
} from '@constants/elasticSearch'
import { toast } from 'react-toastify'
import cn from 'clsx'
import { parseDocumentFromElastic } from '@/utils/elasticsearch'
import Pagination from '@/components/shared/Pagination'
import CircleSpinner from '@/components/shared/CircleSpinner'
import TableHeaderManager from '@/components/shared/TableHeaderManager/TableHeaderManager'
import { HIDE_COL_ON_INDEX, SEARCH_HEADERS } from '@/constants'
import SearchInput from '@components/shared/SearchInput'

const ITEMS_PER_PAGE = 20

const CollectionESSearchWildcardPane = ({
    className,
    vm,
}) => {
    
    const [loading, setLoading] = useState(false)
    const [pageIndex, setPageIndex] = useState(0)
    const [type, setType] = useState('best_fields')
    
    const [documentSearchResults, setDocumentSearchResults] = useWireState(store.documentSearchResults)
    
    useAbortableFetch(async () => {
        
        // if (!vm.documentSearchQuery?.length) {
        //     setResults([])
        //     return
        // }
        
        if (!vm.currentCollection?.id) return
        
        setLoading(true)
        
        // @todo WIP need to map when to use which index + strategy,
        // but for now, we just want broad search for inner docs
        const engine = (
            vm.currentCollection?.isParse
                ? ES_ENGINE_INDEX_DOCUMENTS
                : ES_ENGINE_DOCUMENTS
        ) + ES_INDEX_SUFFIXES_BY_STRATEGY[ES_INDEX_STRATEGY_INNER]
        
        const opts = {
            collectionId: vm.currentCollection?.id,
            q: vm.documentSearchQuery,
            type,
            field: vm.sortField,
            order: vm.sortOrder,
            search_after: pageIndex > 0 ? documentSearchResults.search_after : [],
            offset: (pageIndex * ITEMS_PER_PAGE),
            limit: ITEMS_PER_PAGE,
        }
        
        try {
            
            const data = await actions.searchElasticWildcard(engine, opts)
            
            data.rows = parseDocumentFromElastic(data.rows)
            setDocumentSearchResults(data)
            
        } catch (e) {
            
            console.error(e)
            toast.error('Failed to Search by the given text')
            
        }
        
        setLoading(false)
        
    }, [
        vm.currentCollection?.isParse,
        vm.documentSearchQuery,
        vm.sortField,
        vm.sortOrder,
        pageIndex,
        type,
    ])
    
    useEffect(() => {
        setPageIndex(0)
    }, [
        vm.sortField,
        vm.sortOrder,
    ])
    
    return (
        
        <div className={cn('CollectionESSearchWildcardPane', className)}>
            
            <header className="
                flex items-center content-center w-full gap-4 sticky
                top-[0] left-[0] bg-base-100">
                <div>
                    <div className="text-base">Found {documentSearchResults?.count ?? '0'} Results</div>
                    <div className="text-sm w-[142px]">
                        Total: {documentSearchResults?.rows?.length ?? '0'} /
                        {' '}
                        Selected: {vm.markedDocuments.length}
                    </div>
                </div>
                <div className="relative w-full shrink flex gap-2">
                    <select
                        className="select select-sm select-bordered bg-transparent full-text-select"
                        value={type}
                        onChange={e => setType(e.target.value)}>
                        <option value="best_fields">Fuzzy</option>
                        <option value="phrase">Exact</option>
                    </select>
                    <SearchInput
                        className="full-text-search-input w-full shrink pl-18"
                        value={vm.documentSearchQuery}
                        placeholder="Search (via wildcards)..."
                        onKeyUp={e => e.key === 'Escape' && vm.setDocumentSearchQuery('')}
                        onChange={e => vm.setDocumentSearchQuery(e.target.value)} />
                </div>
                {/* <div className="text-sm shrink-0">
                    {results?.count} Results
                </div> */}
                <TableHeaderManager
                    storeName="documentHeaders"
                    headers={SEARCH_HEADERS.filter(sh => !HIDE_COL_ON_INDEX.includes(sh.id))} />
            </header>
            {loading &&
                <CircleSpinner className="absolute-centered" />
            }
            {!loading && <DocumentSearchResultsTable
                documents={documentSearchResults?.rows}
                top="0px"
                markedDocuments={vm.markedDocuments}
                setMarkedDocuments={vm.setMarkedDocuments} />
            }
            <div className="flex justify-center w-full mx-auto mb-3 sticky bottom-[0] bg-dark py-2">
                <Pagination
                    count={documentSearchResults?.count}
                    itemsPerPage={ITEMS_PER_PAGE}
                    forcePage={pageIndex}
                    setPageIndex={setPageIndex} />
            </div>
            {/* <div><pre><code className="text-white">{JSON.stringify(results, null, 4)}</code></pre></div> */}
        </div>
        
    )
    
}

export default CollectionESSearchWildcardPane
